import React from "react";
import CampoComboParametro from "../../../UI/campos/CampoComboParametro.js";
import CampoEditableMultilinea from "../../../UI/campos/CampoEditableMultilinea.js";
import CampoEditableNumero from "../../../UI/campos/CampoEditableNumero.js";
import CampoEditableTexto from "../../../UI/campos/CampoEditableTexto.js";
import * as TipoEdicion from "../../../constantes/TipoEdicion.js";
import * as TipoParametro from "../../../constantes/TipoParametro.js";
import styles from "../Parametros.module.css";

const Campos = {
  CODIGO: "codigo",
  NOMBRE: "nombre",
  DESCRIPCION: "descripcion",
  OFICIALIDAD: TipoParametro.TIPO_OFICIALIDAD.codigo,
  NIVEL_PAIS: "nivelPais",
}

const CamposTipoTorneo = (props) => {
  const parametro = props.parametro;
  const tipoEdicion = props.tipoEdicion;

  const onCampoChange = (nombre, valor) => {
    switch (nombre) {
      case Campos.CODIGO:
        props.onCampoChange({ ...parametro, codigo: valor });
        break;
      case Campos.NOMBRE:
        props.onCampoChange({ ...parametro, nombre: valor });
        break;
      case Campos.DESCRIPCION:
        props.onCampoChange({ ...parametro, descripcion: valor });
        break;
      case Campos.TIPO_OFICIALIDAD:
        props.onCampoChange({ ...parametro, tipoOficialidad: valor });
        break;
      case Campos.NIVEL_PAIS:
        props.onCampoChange({ ...parametro, nivelPais: valor });
        break;
      default:
    }
  };

  return (
    <React.Fragment>
      <table className={`${styles.tablaDatos}`}>
        <tbody>
          <tr>
            <td className={`${styles.titulo}`}>Código</td>
            <td className={`${styles.valor}`}>
              <CampoEditableNumero
                nombre={Campos.CODIGO}
                valor={parametro && parametro.codigo}
                editar={tipoEdicion === TipoEdicion.ALTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Nombre</td>
            <td className={`${styles.valor}`}>
              <CampoEditableTexto
                nombre={Campos.NOMBRE}
                valor={parametro && parametro.nombre}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Descripción</td>
            <td className={`${styles.valor}`}>
              <CampoEditableMultilinea
                nombre={Campos.DESCRIPCION}
                valor={parametro && parametro.descripcion}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                filas={3}
                columnas={50}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Oficialidad</td>
            <td className={`${styles.valor}`}>
              <CampoComboParametro
                nombre={Campos.OFICIALIDAD}
                tipoParametro={TipoParametro.TIPO_OFICIALIDAD}
                estilo={`${styles.comboDatos}`}
                valor={parametro && parametro.oficialidad}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Nivel País</td>
            <td className={`${styles.valor}`}>
              <CampoEditableNumero
                nombre={Campos.NIVEL_PAIS}
                valor={parametro && parametro.nivelPais}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default CamposTipoTorneo;
